import { MontuMessage } from "@repo/components/src/shared/chat/types";
import { Input, InputField } from "@repo/components/src/ui/input";
import { DocumentPickerAsset } from "expo-document-picker";
import { ComponentProps, useCallback } from "react";
import { TextInputKeyPressEvent } from "react-native";
import { ComposerProps } from "@kesha-antonov/react-native-chat";

const DEFAULT_PLACEHOLDER = "Escribe un mensaje...";

type ExtendedComposerProps = ComposerProps & {
  inputProps?: ComponentProps<typeof Input>;
  onSend?(
    messages: Partial<MontuMessage> | Partial<MontuMessage>[],
    shouldResetInputToolbar: boolean,
  ): void;
  documentPicker: DocumentPickerAsset | null;
};

export default function GiftedChatComposer(props: ExtendedComposerProps) {
  const {
    text = "",
    textInputProps,
    inputProps,
    onSend,
    documentPicker,
  } = props;
  const placeholder = textInputProps?.placeholder ?? DEFAULT_PLACEHOLDER;

  const handleKeyPress: ComponentProps<typeof InputField>["onKeyPress"] =
    useCallback(
      (e: TextInputKeyPressEvent) => {
        // @ts-expect-error : type issue
        if (e.nativeEvent.key === "Enter" && !e.nativeEvent.shiftKey) {
          e.preventDefault();
          text.trim() &&
            onSend?.(
              {
                text: text.trim(),
                document: documentPicker
                  ? {
                      uri: documentPicker.uri,
                      name: documentPicker.name,
                      mimeType: documentPicker.mimeType || "",
                    }
                  : undefined,
              },
              true,
            );
        }
      },
      [text, onSend, documentPicker],
    );
  return (
    <Input
      size="md"
      {...inputProps}
      style={[inputProps?.style]}
      className={`flex-1 px-4 rounded-xl h-fit bg-background-50 border border-outline-100 data-[focus=true]:border-brand-400 data-[focus=true]:bg-background-0 transition-colors ${
        inputProps?.className ?? ""
      }`}
    >
      <InputField
        testID={placeholder}
        accessible
        accessibilityLabel={placeholder}
        placeholder={placeholder}
        multiline
        value={text}
        underlineColorAndroid="transparent"
        className="py-2 px-1 text-sm placeholder:text-typography-400 field-sizing-content min-h-0 md:max-h-96 max-h-56"
        onKeyPress={handleKeyPress}
        returnKeyType="send"
        {...textInputProps}
      />
    </Input>
  );
}
